import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	MEDIUM: 'medium',
	STANDARD: 'standard',
};
export const PlusIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '6';
			case SIZE.MEDIUM:
				return '9';
			case SIZE.STANDARD:
				return '14';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '6';
			case SIZE.MEDIUM:
				return '9';
			case SIZE.STANDARD:
				return '14';
			default:
				return '14';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				width={getWidth(size)}
				height={getHeight(size)}
				viewBox="0 0 14 14"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Top-Menu---Hover" transform="translate(-22.000000, -18.000000)" fill={color}>
						<g id="Top-Menu" transform="translate(-1342.000000, 0.000000)">
							<g id="PlusButton" transform="translate(1342.000000, 0.000000)">
								<g id="Plus" transform="translate(22.000000, 18.000000)">
									<rect id="Rectangle-5" x="6" y="0" width="2" height="14"></rect>
									<rect
										id="Rectangle-5"
										transform="translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) "
										x="6"
										y="0"
										width="2"
										height="14"
									></rect>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

PlusIcon.SIZE = SIZE;
PlusIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.STANDARD]),
};

export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
